<template>
  <el-dialog title="密码修改" close-on-click-modal :visible.sync="visible" width="400px">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="原密码" prop="oldPassword" v-if="!oldPassword">
        <el-input type="password" v-model="form.oldPassword" placeholder="请输入旧密码" />
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword">
        <el-input type="password" v-model="form.newPassword" placeholder="请输入新密码" />
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input type="password" v-model="form.confirmPassword" placeholder="请再次输入新密码" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="savePasswrd">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'ModifyPassword',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [String, Number],
      default: ''
    },
    oldPassword: {
      type: String,
      default: ''
    }
  },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    const password = (rule, value, callback) => {
      const reg = /^[(a-z|A-Z|0-9)]{6,12}$/
      if (value && !reg.test(value)) {
        callback(new Error('请输入6-12英文字母或数字'))
      } else {
        callback()
      }
    }
    return {
      form: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        oldPassword: [{ required: true, validator: password, trigger: ['blur', 'change'] }],
        newPassword: [{ required: true, validator: password, trigger: ['blur', 'change'] }],
        confirmPassword: [{ required: true, validator: validatePass, trigger: ['blur', 'change'] }]
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.form.resetFields()
        })
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false)
    },
    savePasswrd() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const info = {
            oldPassword: this.oldPassword || this.form.oldPassword,
            newPassword: this.form.newPassword,
            userId: this.userId
          }
          this.$axios.post(this.$apis.system.updatePassword, info).then(() => {
            this.handleClose()
            this.$emit('success')
          })
        }
      })
    }
  }
}
</script>
